import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --hero-image-padding: calc(44rem / var(--default-rem-px-count));
    }

    .edward-layout {
      grid-template-rows:
        minmax(0, auto)
        minmax(0, auto);
      max-width: 100%;
    }

    .image {
      grid-column: 1 / 9;
      grid-row: 1;
    }

    .header {
      grid-column: 2 / 4;
      grid-row: 2;
    }

    .cta-btn {
      grid-column: 6 / 8;
      grid-row: 2;
      place-self: start end;
    }

    h1 {
      font-weight: 400;
      font-size: calc(24rem / var(--default-rem-px-count));
      letter-spacing: -0.54px;
      line-height: calc(25rem / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      font-size: calc(14rem / var(--default-rem-px-count));
      letter-spacing: -0.18px;
      line-height: calc(21rem / var(--default-rem-px-count));
    }

    .image img {
      max-height: 100vw;
      max-width: 100vw;
      object-fit: fill;
    }

    .image-caption {
      padding-top: 1em;
      border-top: 1px solid #c0c0c0;
      display: flex;
      justify-content: space-between;
      margin-top: calc(14rem / var(--default-rem-px-count));
    }

    .image-caption > span > p {
      margin: 0;
    }

    @media (min-width: 600px) {
      :host {
        --hero-image-padding: calc(44rem / var(--default-rem-px-count));
      }

      h1 {
        font-size: calc(40rem / var(--default-rem-px-count));
        letter-spacing: -1.6px;
        line-height: calc(48rem / var(--default-rem-px-count));
      }

      .edward-layout {
        grid-template-rows:
          minmax(0, auto)
          minmax(0, auto)
          var(--top-padding-height);
      }

      .image {
        grid-column: 2 / 14;
        grid-row: 1;
      }

      .image img {
        min-height: 250px;
        width: 100%;
        max-height: unset;
      }

      .header {
        grid-column: 2 / 6;
        grid-row: 2;
        padding-top: var(--hero-image-padding);
      }

      .description {
        grid-column: 7 / 10;
        grid-row: 2;
        padding-top: var(--hero-image-padding);
        font-size: calc(16rem / var(--default-rem-px-count));
        letter-spacing: -0.24px;
        line-height: calc(24rem / var(--default-rem-px-count));
      }

      .cta-btn {
        grid-column: 12 / 14;
        grid-row: 2;
        padding-top: var(--hero-image-padding);
        place-self: normal right;
      }
    }

    @media (min-width: 1024px) {
      img {
        min-height: 400px;
      }

      .description {
        grid-column: 8 / 11;
      }
    }
  `,
];
